import { uniqueId } from 'lodash';

import PAYLOAD_CONDITION_OPERATORS from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext/PAYLOAD_CONDITION_OPERATORS';

export default function buildEmptyPayloadCondition() {
  return {
    id: uniqueId('payload-condition-'),
    path: '',
    operator: PAYLOAD_CONDITION_OPERATORS.EQUALS,
    value: '',
  };
}
